import { BsChevronDown } from "react-icons/bs";
import { AiOutlineSetting } from "react-icons/ai";
//svg
import { ReactComponent as Building } from "../../asset/svg/building.svg";
import { ReactComponent as Request } from "../../asset/svg/request.svg";
import { ReactComponent as Roster } from "../../asset/svg/roster.svg";
import { ReactComponent as Report } from "../../asset/svg/report.svg";
import { SettingTwoTone, TeamOutlined } from "@ant-design/icons";

export const URL = {
  // url
  home: "/",
  register: "/register",
  login: "/login",
  forgot: "/forgot",
  setting: "/setting",
  branch: "/branchs",
  branchAdd: "/branchs/add",
  branchDetail: "/branchs/detail/:id/:type",
  voucherAdd: "/branchs/detail/:id/voucher/add",
  voucherDetail: "/branchs/detail/:id/voucher/detail/:packageId",
  staffDetail: "/branchs/detail/:id/staff/:userId",
  // roster
  roster: "/roster",
  // request
  request: "/request",
  // report
  report: "/report",
  timeTracking: "/report/time-tracking",
  cashupReportList: "/report/cashup/list",
  cashupReportDetail: "/report/cashup/:shopId/detail",
  incomeByStaff: "report/cashup/income-by-staff",
  incomeByStaffDetail: "/report/cashup/:shopId/income-by-staff/detail",
  payout: "/payout",
  payoutList: "/payout/list",
  payoutSetting: "/payout/setting",
  payoutReport: "/report/payout-report",
  payrateBonus: "/payout/payrate-bonus",
  //user management
  user: "/user",
  //dev
  dev: "/dev",
};

// -------------------------- ITEM MAPPING --------------------------
export const newItems = (t, language) => {
  const items = {
    home: {
      title: "Branch",
      url: URL.home,
      key: "1",
      hightlight: ["1"],
      arrow: false,
      icon: <Building style={{ width: 10 }} />,
    },
    dashboard: {
      title: "Branch",
      url: URL.home,
      key: "1",
      hightlight: ["1"],
      arrow: false,
      icon: <Building style={{ width: 10 }} />,
    },
    login: {
      title: t("login"),
      url: URL.home,
      key: "1",
      hightlight: ["1"],
      arrow: false,
    },
    verification: {
      title: t("verification"),
      url: URL.home,
      key: "1",
      hightlight: ["1"],
      arrow: false,
    },
    register: {
      title: t("register"),
      url: language + URL.register,
      key: "2",
      hightlight: ["2"],
      arrow: false,
    },
    forgot: {
      title: t("forgot"),
      url: language + URL.forgot,
      key: "3",
      hightlight: ["3"],
      arrow: false,
    },
    roster: {
      title: "Roster",
      url: URL.roster,
      key: "4",
      hightlight: ["4"],
      arrow: false,
      icon: <Roster style={{ width: 10 }} />,
    },
    payout: {
      title: "Payout",
      url: URL.payout,
      key: "7",
      hightlight: ["7"],
      arrow: false,
      icon: <Roster style={{ width: 10 }} />,
    },
    payoutReport: {
      title: "Payout Report",
      url: URL.payoutReport,
      key: "8",
      hightlight: ["8"],
      arrow: false,
      icon: <Roster style={{ width: 10 }} />,
    },
    payrateBonus: {
      title: "Payrate & Bonus",
      url: URL.payrateBonus,
      key: "12",
      hightlight: ["12"],
      arrow: false,
      icon: <Roster style={{ width: 10 }} />,
    },
    request: {
      title: "Leave Request",
      url: URL.request,
      key: "5",
      hightlight: ["5"],
      arrow: false,
      icon: <Request style={{ width: 10 }} />,
    },
    report: {
      title: "Report",
      url: URL.report,
      key: "6",
      hightlight: ["6"],
      arrow: false,
      icon: <Report style={{ width: 10 }} />,
    },
    setting: {
      title: t("setting"),
      url: language + URL.setting,
      key: "9",
      hightlight: ["9"],
      arrow: false,
      icon: <AiOutlineSetting />,
    },

    //user management
    user: {
      title: "Users",
      url: URL.user,
      key: "11",
      hightlight: ["11"],
      arrow: false,
      icon: <TeamOutlined />,
    },

    dev: {
      title: "Dev",
      url: URL.dev,
      key: "10",
      hightlight: ["10"],
      arrow: false,
      icon: <SettingTwoTone />,
    },
  };
  return items;
};

// -------------------------- BREAD CRUMB --------------------------
export const newBreadCrumb = (items) => {
  const breadCrumb = {
    home: null,
    login: [items.login],
    verification: [items.login, items.verification],
    dashboard: [items.home, items.dashboard],
    register: [items.login, items.register],
    forgot: [items.login, items.forgot],
    account: [items.home, items.account],
    setting: [items.home, items.setting],
  };
  return breadCrumb;
};

// -------------------------- MENU --------------------------
export const setMenuItem = (props) => {
  const { title, url, key, arrow, icon, children } = props;
  const href = url;
  let label = href ? (
    <>
      <a href={href} target="_self" rel="noopener noreferrer">
        {title}
      </a>
      {arrow ? (
        <BsChevronDown
          style={{ fontSize: 10, marginLeft: 5 }}
          className="arrow-down"
        />
      ) : null}
    </>
  ) : (
    title
  );
  return { key, children, label, icon };
};

export const newAuthMenu = (items, logged) => {
  const loggedin = [setMenuItem({ ...items.account })];
  const anonymous = [
    setMenuItem({ ...items.register }),
    setMenuItem({ ...items.login }),
  ];
  const menu = logged === null ? [] : logged === true ? loggedin : anonymous;
  return menu;
};

export const newDashboard = (items) => {
  const dashboard = [items.account, items.setting];
  return dashboard;
};

export const newMenus = (items) => {
  const menu = [
    setMenuItem({ ...items.dashboard }),
    setMenuItem({ ...items.user }),
    setMenuItem({ ...items.roster }),
    setMenuItem({ ...items.request }),
    setMenuItem({ ...items.report }),
    setMenuItem({ ...items.payout }),
    // setMenuItem({ ...items.setting }),
    // setMenuItem({ ...items.dev}),
  ];
  return menu;
};
